import { render, staticRenderFns } from "./CalendarSetting.vue?vue&type=template&id=0e2e510a&scoped=true"
import script from "./CalendarSetting.vue?vue&type=script&lang=js"
export * from "./CalendarSetting.vue?vue&type=script&lang=js"
import style0 from "./CalendarSetting.vue?vue&type=style&index=0&id=0e2e510a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e510a",
  null
  
)

export default component.exports